import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import ColumnData from "../pipelineComponents/ColumnData";
import Card from "./Card";
import { Sidebar } from "primereact/sidebar";
import DealService from "../Services/DealService.js";
import { ToastContainer } from "react-toastify";
import { getIcons } from "../Constant/Constant.js";
import { Timeline } from "primereact/timeline";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../App.css";
import { showErrorToast } from "../Constant/Notification.js";
import { bookingPaymentType } from "../../Enum.js";
import Modal from "react-modal";
import ReportPDFModal from "./ReportPDFModal.jsx";
import { MultiSelect } from "primereact/multiselect";
import ViewSiteImageModel from "./ViewSiteImageModel.jsx";
import DashedCircleLoader from "./DashedCircleLoader.jsx";
import SidebarHeader from "../Form/BackArrow/SidebarHeader.jsx";
import DealInfoCard from "./DealInfoCard.jsx";
import SiteVisitHistoryCard from "./SiteVisitHistoryCard.jsx";
import DealHistoryCard from "./DealHistoryCard.jsx";
import DailyUpdateCommentCard from "./DailyUpdateCommentCard.jsx";
import ViewAdvanceAmountCard from "./ViewAdvanceAmountCard.jsx";
import { teamIds, userId } from "../../utils/storage.js";
import { dealStagesData } from "../../Enum/PipelineEnumConstants.js";

const KanbanBoard = ({ team, property, setLoading, userList , onCardClick}) => {
  const icons = getIcons();
  const [columns, setColumns] = useState([]);
  const [dealCount, setDealCount] = useState(
    Object.keys(dealStagesData).reduce((acc, stage) => ({ ...acc, [stage]: 0 }), {})
  );
  const [nextPageToken, setNextPageToken] = useState(
    Object.keys(dealStagesData).reduce((acc, stage) => ({ ...acc, [stage]: "" }), {})
  );
  const [dealOverAllSqft, setDealOverAllSqft] = useState(
    Object.keys(dealStagesData).reduce((acc, stage) => ({ ...acc, [stage]: 0 }), {})
  );
  const [loader, setLoader] = useState(false);
  const [visibleRight, setVisibleRight] = useState(false);
  const [dealInfoSelected, setDealInfoSelected] = useState({});
  const [dealStageSelected, setDealStageSelected] = useState("");
  const [reload, setReload] = useState(false);

  const userData = JSON.parse(localStorage.getItem("userData"));

  const userRole = userData?.user?.role;
  const bodTeamId = userData?.teamId?.[0]?.id;

  const colorClassMapping = {
    "#B9DAD0": "bg-custom-light-green",
    "#94C8B7": "bg-custom-greenish",
    "#70B89E": "bg-custom-medium-green",
    "#4BA785": "bg-custom-dark-green",
    "#03B070": "bg-custom-bright-green",
    "#07BA77": "bg-custom-bright-green-2",
    "#E0A0A0": "bg-custom-soft-red",
  };

  const dateTimeConversion = (timestamp) => {
    let dateMDY = "";
    let time = "";
    let date = new Date(timestamp);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const inputDate = new Date(date);
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate.getTime() === today.getTime()) {
      dateMDY = "Today";
    } else if (inputDate.getTime() === yesterday.getTime()) {
      dateMDY = "Yesterday";
    } else {
      dateMDY = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    }

    let hours = date.getHours();
    let minutes = String(date.getMinutes()).padStart(2, "0");
    let period = hours >= 12 ? "PM" : "AM";

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours -= 12;
    }

    time = `${String(hours).padStart(2, "0")}:${minutes} ${period}`;
    return { dateMDY, time };
  };

    const fetchStageData = async (stageName, stageId, teamFilter = null, propertyFilter = null, next = "") => {
      setLoader(true);
      try {
        const body = {
          limit: 10,
          next,
          direction: "next",
          role: userRole,
          teamIds:  teamIds || [],
          filteredTeamId: teamFilter || null,
          userId ,
          dealStageId: [stageId],
          propertyId: propertyFilter || null,
        };

        const response = await DealService.fetchPipelineData(body);
        const dealList = response?.data?.deals || [];

        const tasks = dealList.map((item) => {
          let status = item.scheduleStatus || "";
          let dateMDY = item.scheduledDate || "";
          let time = item.scheduledTime || "";

          if (item.scheduledTime && !dateMDY) {
            const dateObj = dateTimeConversion(item.scheduledTime);
            dateMDY = dateObj.dateMDY;
            time = dateObj.time;
          }

          return {
            id: item.id,
            squareFeet: `${item.squareFeet} Sq feet`,
            approx: ["Plot Booked", "Advance Amount Update", "Fully Registered", "Registration InProgress", "Deal Lost After Booking"].includes(item.currentStage) ? "Fixed" : "Approx",
            status,
            icon: "",
            customerName: item.lead,
            siteName: item.property,
            propertyId: item.propertyId,
            stage: item.currentStage,
            teamMemberName: item.responsiblePerson?.name,
            teamDetail: item.team,
            teamId: item.teamId,
            day: dateMDY,
            time,
            bookedTimestamp: item.bookedDaysCount,
            recentComment: item.lastComment,
          };
        });

        return {
          title: stageName,
          stageId,
          tasks,
          loader: false,
          bgColor: ColumnData.find((col) => col.title === stageName)?.bgColor || "#FFFFFF",
          next: response?.data?.next || "",
          overallSquareFeet: response?.data?.overallSquareFeet || 0,
          maxDealCount: response?.data?.maxDealCount || 0,
        };
      } catch (error) {
        console.error(`Error fetching for ${stageName}:`, error);
        return {
          title: stageName,
          stageId,
          tasks: [],
          loader: false,
          bgColor: ColumnData.find((col) => col.title === stageName)?.bgColor || "#FFFFFF",
          next: "",
          overallSquareFeet: 0,
          maxDealCount: 0,
          error,
        };
      }
    };

    const getPipelineDataForAllStages = async (teamFilter = null, propertyFilter = null , initialLoad) => {
      setLoading(true);
      if(initialLoad)
      {
        setNextPageToken({})
      }
     
      try {
        const requests = Object.entries(dealStagesData).map(([stageName, stageId]) =>
          fetchStageData(stageName, stageId, teamFilter, propertyFilter, initialLoad ? "" : nextPageToken[stageName] )
        );

        const results = await Promise.all(requests);
        setColumns(results);
        setDealCount((prev) => ({
          ...prev,
          ...results.reduce((acc, result) => ({
            ...acc,
            [result.title]: result.maxDealCount,
          }), {}),
        }));
        setDealOverAllSqft((prev) => ({
          ...prev,
          ...results.reduce((acc, result) => ({
            ...acc,
            [result.title]: result.overallSquareFeet,
          }), {}),
        }));
        setNextPageToken((prev) => ({
          ...prev,
          ...results.reduce((acc, result) => ({
            ...acc,
            [result.title]: result.next,
          }), {}),
        }));
      } catch (err) {
        console.error("Unexpected error fetching pipeline data:", err);
        showErrorToast("Failed to fetch pipeline data");
      } finally {
        setLoading(false);
        setLoader(false);
      }
    };

    useEffect(() => {
      getPipelineDataForAllStages(team, property, true);  
    }, [team, property, reload]);

  const handleScroll = async (e, stageId, index) => {
    const div = e.target;
    if (div.scrollHeight - div.scrollTop - div.clientHeight <= 5 && !loader) {
      if (columns[index].tasks.length < dealCount[stageId]) {
        setLoader(true);
        const stageName = columns[index].title;
        const stageData = await fetchStageData(stageName, dealStagesData[stageName], team, property, nextPageToken[stageName]);
        setColumns((prev) =>
          prev.map((col, i) =>
            i === index ? { ...col, tasks: [...col.tasks, ...stageData.tasks], loader: false } : col
          )
        );
        setNextPageToken((prev) => ({ ...prev, [stageName]: stageData.next }));
        setLoader(false);
      }
    }
  };

  const showDealInfo = async (taskData, column) => {
    console.log("showDealInfo called with taskData:", taskData, "and column:", column);
    try {
      const dealInfo = await DealService.showDealInfo(taskData.id);
      setDealID(taskData.id);
      setSelectedDealData(dealInfo.data);
      setSelectedDealCommentsList(dealInfo.data.commentsList);
      const dealData = dealInfo.data;
      setDealStageSelected(column.title);
      setDealInfoSelected(dealData);
      setVisibleRight(true);
    } catch (error) {
      showErrorToast(error.message);
    }
  };
  useEffect(() => {
    if (typeof onCardClick === 'function') {
      console.log("Passing showDealInfo to parent");
      onCardClick(showDealInfo); 
    } else {
      console.warn("onCardClick is not a function", onCardClick);
    }
  }, [onCardClick]);
  
  

  const [dealHistoryVisible, setDealHistoryVisible] = useState(false);
  const [viewAdvanceVisible, setViewAdvanceVisbile] = useState(false);
  const [viewPaymentData, setViewPaymentData] = useState();
  const [dailyUpdateComment, setDailyUpdateComment] = useState(false);
  const [events, setEvents] = useState([]);
  const [dealID, setDealID] = useState();
  const [selectedDealData, setSelectedDealData] = useState();
  const [selectedDealCommentsList, setSelectedDealCommentsList] = useState([]);
  const [sitevisitHistoryVisible, setsitevisitHistoryVisible] = useState(false);
  const [sitevisitHistory, setSitevisitHistory] = useState([]);
  const [siteVisitImages, setSiteVisitImages] = useState([]);

  const handleOpenSiteVisitHistory = async () => {
    setVisibleRight(false);
    setsitevisitHistoryVisible(true);
    try {
      const response = await DealService.sitevisitHistory(dealID);
      const history = response.data.history.map((item) => ({
        responsible: item.responsible,
        property: item.property,
        timestamp: `${new Date(item.visitTime).toLocaleDateString("en-GB")} ${new Date(item.visitTime).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        })}`,
      }));
      setSitevisitHistory(history);
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  const handleCloseSiteVisitHistory = () => {
    setsitevisitHistoryVisible(false);
    setVisibleRight(true);
  };

  const handleDealHistory = async () => {
    setVisibleRight(false);
    setDealHistoryVisible(true);
    try {
      const response = await DealService.dealHistory(dealID);
      const history = response.data.history.map((item) => ({
        log: item.log,
        timestamp: item.timeStamp,
      }));
      setEvents(history);
    } catch (error) {
      console.error("Error fetching deal history:", error);
      showErrorToast(error.message);
    }
  };

  const handleDealHistoryBack = () => {
    setDealHistoryVisible(false);
    setVisibleRight(true);
  };

  const handleViewAdvanvcePayment = () => {
    setVisibleRight(false);
    setViewAdvanceVisbile(true);
  };

  const fetchTransactionData = async () => {
    try {
      const response = await DealService.showDealInfo(dealID);
      setTransactionData(response.data.advancePaymentList);
    } catch (err) {
      showErrorToast(err.message);
    }
  };

  useEffect(() => {
    if (viewAdvanceVisible) {
      fetchTransactionData();
    }
  }, [viewAdvanceVisible]);

  const handleAdvancePaymentBack = () => {
    setViewAdvanceVisbile(false);
    setVisibleRight(true);
  };

  const handleDailyUpdateComment = () => {
    setDailyUpdateComment(true);
    setVisibleRight(true);
  };

  const handleDailyUpdateCommentBack = () => {
    setDailyUpdateComment(false);
    setVisibleRight(true);
  };

  const [transactionData, setTransactionData] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalSiteImages, setIsOpenModalSiteImages] = useState(false);

  const handleReport = () => {
    setVisibleRight(false);
    setIsOpenModal(true);
  };

  const handleViewSiteImages = async (dealId) => {
    try {
      const response = await DealService.fetchDealImages(dealId);
      if (response) {
        setSiteVisitImages(response?.data?.dealImages);
        setIsOpenModalSiteImages(true);
        setVisibleRight(false);
      }
    } catch (err) {
      console.log(err);
      showErrorToast(err.message);
    }
  };

  const [selectedPaymentType, setSelectedPaymentType] = useState([]);

  const handleFilterPaymentType = (e) => {
    setSelectedPaymentType(e.target.value);
  };

  const filteredTransactions = transactionData.filter(
    (advancePayment) =>
      selectedPaymentType.length === 0 ||
      selectedPaymentType.includes(advancePayment.advanceAmountPaymentType)
  );

  const totalRefundedAmount = selectedDealData?.advancePaymentList.reduce(
    (total, value) => {
      if (value?.paymentDefinition === 2 || value?.paymentDefinition === 3) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    },
    0
  );

  const totalReceivedAmountOfPaymentType1 = selectedDealData?.advancePaymentList.reduce(
    (total, value) => {
      if (value?.paymentDefinition === 1) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    },
    0
  );

  const totalReceivedAmountOfPaymentType2 = selectedDealData?.advancePaymentList.reduce(
    (total, value) => {
      if (value?.paymentDefinition === 2) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    },
    0
  );

  const totalReceivedAmountOfPaymentType3 = selectedDealData?.advancePaymentList.reduce(
    (total, value) => {
      if (value?.paymentDefinition === 3) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    },
    0
  );

  const totalReceivedAmount =
    totalReceivedAmountOfPaymentType1 -
    totalReceivedAmountOfPaymentType2 -
    totalReceivedAmountOfPaymentType3;

  const totalCostOfProperty = selectedDealData?.budget;
  const totalCostOfPropertyWithRegistration =
    selectedDealData?.budget +
    selectedDealData?.registrationPayments?.totalRegistrationAmount;
  let pendingAmount = totalCostOfPropertyWithRegistration - totalReceivedAmount;
  pendingAmount = pendingAmount > 0 ? pendingAmount : 0;

  let excessAmount =
    totalCostOfPropertyWithRegistration -
    totalReceivedAmount +
    totalReceivedAmountOfPaymentType2;
  excessAmount = excessAmount < 0 ? Math.abs(excessAmount) : 0;

  return (
    <>
      <ToastContainer />
      <DragDropContext>
        <div className="w-12/12 h-screen overflow-x-auto pb-4 custom-scrollbar pipeline">
          <div className="flex mx-10 mt-4 gap-5">
            {columns.map((column, index) => {
              const bgColorClass = colorClassMapping[column.bgColor];
              return (
                <div key={index} style={{ minWidth: "380px" }}>
                  <div className="flex flex-col">
                    <div className="flex flex-col gap-2">
                      <h1 className="text-xl font-bold 4xl:text-2xl">
                        {column?.title === "Plot Booked" ? "Unit Booked" : column.title === "Registration InProgress" ? "Registration In Progress" : column.title == "Site Visit" ? "Proposed Site Visit" : column.title}
                      </h1>
                      <div className="flex gap-2">
                        <div
                          className={`text-l font-bold text-center 4xl:text-2xl 4xl:w-auto 4xl:p-1 whitespace-nowrap ${bgColorClass} rounded-xl w-6/12`}
                        >
                          {dealOverAllSqft[column?.title?.trim()] || 0} Sqft
                        </div>
                        <h1 className="text-l font-medium 4xl:text-2xl">
                          {`(${dealCount[column?.title?.trim()] || 0} Deals)`}
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="w-full">
                    <div
                      onScroll={(e) => handleScroll(e, column.title, index)}
                      className={`w-12/12 ${bgColorClass} h-[calc(98vh-270px)] overflow-y-auto custom-scrollbar p-4 mt-4 rounded-lg`}
                    >
                      <Droppable droppableId={"" + index}>
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            droppableId={"" + index}
                            className="min-h-32 overflow-y-auto flex flex-col gap-4"
                          >
                            {column?.tasks.map((task, index) => (
                              <div key={index} onClick={() => showDealInfo(task, column)}>
                                <Card
                                  title={column.title}
                                  task={task}
                                  dealId={task.id}
                                  index={index}
                                />
                              </div>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                      {loader && <DashedCircleLoader />}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <Sidebar
          visible={viewAdvanceVisible}
          position="right"
          onHide={() => setViewAdvanceVisbile(false)}
        >
          <ViewAdvanceAmountCard
            handleFilterPaymentType={handleFilterPaymentType}
            selectedDealData={selectedDealData}
            handleAdvancePaymentBack={handleAdvancePaymentBack}
            selectedPaymentType={selectedPaymentType}
            bookingPaymentType={bookingPaymentType}
            totalCostOfProperty={totalCostOfProperty}
            totalReceivedAmount={totalReceivedAmount}
            pendingAmount={pendingAmount}
            excessAmount={excessAmount}
            totalReceivedAmountOfPaymentType3={totalReceivedAmountOfPaymentType3}
            dealStageSelected={dealStageSelected}
            filteredTransactions={filteredTransactions}
          />
        </Sidebar>

        <Sidebar
          visible={dailyUpdateComment}
          position="right"
          onHide={() => setDailyUpdateComment(false)}
        >
          <DailyUpdateCommentCard
            handleDailyUpdateCommentBack={handleDailyUpdateCommentBack}
            selectedDealCommentsList={selectedDealCommentsList}
          />
        </Sidebar>

        <Sidebar
          visible={dealHistoryVisible}
          position="right"
          onHide={() => setDealHistoryVisible(false)}
        >
          <DealHistoryCard
            events={events}
            handleDealHistoryBack={handleDealHistoryBack}
          />
        </Sidebar>

        <Sidebar
          visible={sitevisitHistoryVisible}
          position="right"
          onHide={() => setsitevisitHistoryVisible(false)}
        >
          <SiteVisitHistoryCard
            sitevisitHistory={sitevisitHistory}
            handleCloseSiteVisitHistory={handleCloseSiteVisitHistory}
          />
        </Sidebar>

        <Sidebar
          visible={visibleRight}
          position="right"
          onHide={() => setVisibleRight(false)}
        >
          <DealInfoCard
            icons={icons}
            dealID={dealID}
            dealInfoSelected={dealInfoSelected}
            dealStageSelected={dealStageSelected}
            showDealInfo={showDealInfo}
            onReload={() => {
              setReload(!reload);
              setVisibleRight(false);
            }}
            setVisibleRight={setVisibleRight}
            handleViewAdvanvcePayment={handleViewAdvanvcePayment}
            handleDailyUpdateComment={handleDailyUpdateComment}
            bookingPaymentType={bookingPaymentType}
            paymentType={selectedPaymentType}
            userRole={userRole}
            userList={userList}
            setIsOpenModal={setIsOpenModal}
            handleReport={handleReport}
            handleViewSiteImages={handleViewSiteImages}
            handleOpenSiteVisitHistory={handleOpenSiteVisitHistory}
            handleDealHistory={handleDealHistory}
          />
        </Sidebar>
      </DragDropContext>

      <ReportPDFModal
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        dealID={dealID}
        excessAmount={excessAmount}
        pendingAmount={pendingAmount}
      />
      <ViewSiteImageModel
        data={siteVisitImages}
        isOpenModal={isOpenModalSiteImages}
        onClose={() => {
          setIsOpenModalSiteImages(false);
          setVisibleRight(true);
        }}
      />
    </>
  );
};

export default KanbanBoard;